import { useMutation, useQueryClient } from "@tanstack/react-query";

import { coachApi } from "@/lib/api";

export interface UpdateProfilePayload {
    displayName?: string;
    phone?: string;
    bio?: string | null;
}

/**
 * Ubah profil coach. Sukses → `refreshProfile` (context auth) menyegarkan
 * seluruh app memakai profil baru; `useMutation` tetap mengembalikan janji
 * supaya form bisa menutup modal & menampilkan error spesifik (mis. 409).
 */
export function useUpdateProfile(onSuccess: () => Promise<void> | void) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: UpdateProfilePayload) => coachApi.updateProfile(payload),
        onSuccess: async () => {
            // Cache react-query lama profil perlu dibuang supaya halaman lain
            // (header avatar, dll) ikut segar dari /coach-auth/me berikutnya.
            queryClient.invalidateQueries({ queryKey: ["coach-profile"] });
            await onSuccess();
        },
    });
}
